// @flow
import {Platform} from 'react-native';
import {takeEvery, call, put, select} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import {tripica} from '../../../api/index';
import {
  storePhoneNumbers,
  deleteCurrentShownPhoneNumbers,
  showNewPhoneNumbers,
} from './actions';
import type {ActionType} from './actions';
import HandleErrorService from '../../../lib/handleError';
import {storedPhoneNumbersCountSelector} from './reducer';
import {regionSelector} from '../Region/selectors';
import {setLoading} from '../../LoadingStatus/index';

export function* getAvailablePhoneNumbersSaga(
  action: ActionType,
): Generator<*, *, *> {
  if (action.type !== 'FETCH_AVAILABLE_PHONE_NUMBERS') return;

  yield put(setLoading('getAvailablePhoneNumbers', true));
  const {preferredPhoneNumbers} = action.payload;

  try {
    // first we delete the current shown phone numbers from the store
    yield put(deleteCurrentShownPhoneNumbers());

    const storedPhoneNumbersCount = yield select(
      storedPhoneNumbersCountSelector,
    );
    if (preferredPhoneNumbers || storedPhoneNumbersCount < 10) {
      const region = yield select(regionSelector);
      const phoneRegionName = region && region.phoneRegionName;
      const phoneNumbers = yield call(
        [tripica, 'getAvailablePhoneNumbers'],
        phoneRegionName,
        preferredPhoneNumbers,
      );
      yield put(storePhoneNumbers(phoneNumbers));
    } else {
      // fix for bug in react-native-wheel-picker https://github.com/lesliesam/react-native-wheel-picker/pull/21
      if (Platform.OS === 'android') yield delay(100);
    }

    yield put(showNewPhoneNumbers());
  } catch (e) {
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('getAvailablePhoneNumbers', false));
  }
}

export default function* (): Generator<*, *, *> {
  yield* [
    takeEvery('FETCH_AVAILABLE_PHONE_NUMBERS', getAvailablePhoneNumbersSaga),
  ];
}
